export const INCREMENT = 'INCREMENT';
export const CREATBLOCTXT = 'CREATBLOCTXT';
export const CAT = 'CAT'
export const GETLISTPAYS = 'GETLISTPAYS'